import { PensionPhaseStatus } from "@repo/api";
import { cs } from "@repo/ui";
import { type FC } from "react";
import Attention from ".";

type CorrectPaymentSymbolsProps = {
    pensionPhaseStatus?: PensionPhaseStatus;
};
const CorrectPaymentSymbols: FC<CorrectPaymentSymbolsProps> = ({ pensionPhaseStatus }) => {
    return (
        <>
            {pensionPhaseStatus === PensionPhaseStatus.Payout ? (
                <Attention severity="warning">{cs.global.canceledPermanentPayment}</Attention>
            ) : (
                <Attention severity="warning">
                    Při platbě převodem zadejte pečlivě <strong>variabilní</strong> a <strong>konstantní</strong>{" "}
                    symbol, aby byla platba správně spárována.
                </Attention>
            )}
        </>
    );
};

export default CorrectPaymentSymbols;
